module.exports = __webpack_public_path__ + "static/media/App_Store_Badge_black.2928664f.svg";